/**
 * @desc 退货单分页查询
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.AsMaterialRejectPageRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asMasterialReject/page`, {
      method: "DELETE",

      data: body,
      ...options,
    }),
  );
}
